import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";
//{{host_prod}}/{{client_path}}/clinics/{{eos_id}}/sms-gateway/dashboard


const getDashboardData = (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/sms-gateway/dashboard")
}

const getInbox = (clinicId,criteria="firstName",searchString="",pageNo=0,pageSize=30) =>{
    const params = "?pageNo="+pageNo+"&pageSize="+pageSize+"&"+criteria+"="+searchString;
    console.log(params)
    return axios.get(API_URL+"clinics/"+clinicId+"/sms-gateway/inbox"+params)
}
const getConversation = (clinicId,customer,pageNo=0,pageSize=2) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/sms-gateway/conversation/"+customer+"?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getConversationDetails = (clinicId,customer) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/sms-gateway/conversation/"+customer+"/details")
}
const sendMessage = (clinicId, data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/sms-gateway/send/message",data)
}

const smsgatewayService = {
    getDashboardData,
    getInbox,
    getConversation,
    getConversationDetails,
    sendMessage
}

export default smsgatewayService